import "./App.css";

import { useTranslation } from "react-i18next";
import {
  Button,
  TextField,
  Menu,
  MenuItem,
  IconButton,
  Typography,
  AppBar,
  Toolbar,
  Stack,
  Badge,
  Divider,
  Avatar,
  SwipeableDrawer,
  colors,
  Drawer,
   List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Collapse,
  Tooltip
} from "@mui/material";
import {
  EvStationSharp,
  
  PeopleOutline,
  PeopleAlt,
  Inventory,
  WarehouseOutlined,
  CategoryOutlined,
  Language,
  AssessmentOutlined,
  SettingsOutlined,
  VpnLockOutlined,
  LogoutOutlined,
  ManageAccountsOutlined,
  MessageOutlined,
  CategoryRounded,
  KeyboardReturnOutlined,
  Settings,
  AccountCircle,
  ChevronLeft,
  ExpandMore,
  ExpandLess,
  LocalMallOutlined,
  PointOfSaleOutlined,
  PaymentOutlined,
  ArticleOutlined,
  AdminPanelSettings,
  
  } from "@mui/icons-material";
import {
  styled,
  alpha,
  createTheme,
  ThemeProvider,
  useTheme,
} from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useEffect, useState, useContext } from "react";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import ComstomersComp from "./Components/Admin/CustomersComp";
import CustomersCompForApproval from "./Components/Admin/CustomersCompForApproval";
import UserRegisterComp from "./Components/Security/UserRegisterComp";
import UserAccountChange from "./Components/Security/UserAccountChange";
import LogInModel from "./Components/Security/LogInModel";
import UsersComp from "./Components/Security/UsersComp";
import SecurityComp from "./Components/Security/SecurityComp";
import ItemsComp from "./Components/Admin/ItemsComp";
import ItemCategoriesComp from "./Components/Admin/ItemCategoriesComp";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";

import MenuIcon from "@mui/icons-material/Menu";

import { ShoppingCartContext } from "./Components/Context/ShoppingCartContext";
import { Login } from "@mui/icons-material";
import HomeComp from "./Components/HomeComp";

import NewsComp from "./Components/News/NewsHomeComp";
import SingleStory from "./Components/News/NewsSingleComp";
import EditStory from "./Components/News/NewsEditComp";

import AboutusComp from "./Components/AboutusComp";


import MessagesModel from "./Components/Security/MessagesModel";

//Default
const THEME0 = createTheme({
  typography: {
    fontFamily: 'sans-serif,"Roboto","Helvetica","Arial"',
    fontSize: 12,
  },
});



const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const Languegs = [
  {
    value: "amh",
    label: "Amharic",
  },
  {
    value: "en",
    label: "English",
  },
  {
    value: "oro",
    label: "Afaan Oromoo",
  },
  {
    value: "tig",
    label: "Tigiregna",
  },
  {
    value: "som",
    label: "Somaligna",
  },
  {
    value: "afar",
    label: "Afaregna",
  },
];

function App() {
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);

  const toggleDrawer = () => {
    setOpen(!open);
  };
 
  const drawerWidth = 240;
  //UserProfile
  const [anchorUserPEl, setAnchorUserPEl] = useState(null);
  const UserPOpen = Boolean(anchorUserPEl);
  const handleUserPClick = (event) => {
    setAnchorUserPEl(event.currentTarget);
  };
  const handleUserPClose = () => {
    setAnchorUserPEl(null);
    setOpenDrawer(false);
  };
  //Sales
  const [anchorSalesEl, setAnchorSalesEl] = useState(null);
  const SalesOpen = Boolean(anchorSalesEl);
  const handleSalesClick = (event) => {
    setAnchorSalesEl(event.currentTarget);
  };
  const handleSalesClose = () => {
    setAnchorSalesEl(null);
    setOpenDrawer(false);
  };
  //Purchase
  const [anchorPurchaseEl, setAnchorPurchaseEl] = useState(null);
  const purchaseOpen = Boolean(anchorPurchaseEl);
  const handlePurchaseClick = (event) => {
    setAnchorPurchaseEl(event.currentTarget);
  };
  const handlePurchaseClose = () => {
    setAnchorPurchaseEl(null);
    setOpenDrawer(false);
  };
  //Inventory
  const [anchorInventoryEl, setAnchorInventoryEl] = useState(null);
  const InventoryOpen = Boolean(anchorInventoryEl);
  const handleInventoryClick = (event) => {
    setAnchorInventoryEl(event.currentTarget);
  };
  const handleInventoryClose = () => {
    setAnchorInventoryEl(null);
    setOpenDrawer(false);
  };
  //Cash
  const [anchorCashEl, setAnchorCashEl] = useState(null);
  const CashOpen = Boolean(anchorCashEl);
  const handleCashClick = (event) => {
    setAnchorCashEl(event.currentTarget);
  };
  const handleCashClose = () => {
    setAnchorCashEl(null);
    setOpenDrawer(false);
  };
  //Admins
  const [anchorAdminEl, setAnchorAdminEl] = useState(null);
  const AdminOpen = Boolean(anchorAdminEl);
  const handleAdminClick = (event) => {
    setAnchorAdminEl(event.currentTarget);
    //setAnchorAdminEl(!AdminOpen);
  };
  const handleAdminClose = () => {
    setAnchorAdminEl(null);
    setOpenDrawer(false);
  };
  //Manufacturing
  const [anchorJobEl, setAnchorJobEl] = useState(null);
  const JobOpen = Boolean(anchorJobEl);
  const handleJobClick = (event) => {
    setAnchorJobEl(event.currentTarget);
  };
  const handleJobClose = () => {
    setAnchorJobEl(null);
    setOpenDrawer(false);
  };
  //Finance
  const [anchorFinanceEl, setAnchorFinanceEl] = useState(null);
  const financeOpen = Boolean(anchorFinanceEl);
  const handleFinanceClick = (event) => {
    setAnchorFinanceEl(event.currentTarget);
  };
  const handleFinanceClose = () => {
    setAnchorFinanceEl(null);
    setOpenDrawer(false);
  };
  //Hospital
  const [anchorHospitalEl, setAnchorHospitalEl] = useState(null);
  const hospitalOpen = Boolean(anchorHospitalEl);
  const handleHospitalClick = (event) => {
    setAnchorHospitalEl(event.currentTarget);
  };
  const handleHospitalClose = () => {
    setAnchorHospitalEl(null);
    setOpenDrawer(false);
  };

  const [openDrawer, setOpenDrawer] = useState(false);
  const [openOnSideBar, setOpenOnSideBar] = useState('');
  const {
    selectedItems,
    setGlobalSupplier,
    pageHeader,
    setSelectedItems,
    globalUser,
    setGlobalUser,
    setPageHeader,
    selectedLanguage,
    setSelectedLanguage,
  } = useContext(ShoppingCartContext);

  useEffect(() => {
    i18n.changeLanguage("en");
  }, []);

  return (
   
      <BrowserRouter>
      {/* Top Navigation Bar  */}
        <AppBar position="static" 
        style={{
          zIndex: 1201,
          transition: "margin 0.3s, width 0.3s",
          width: `calc(100% - ${open ? drawerWidth : 0}px)`,
          marginLeft: open ? drawerWidth :globalUser && globalUser!==null ? 40:0,
          // visibility: open ? "hidden" : "visible"
        }}>
          <Toolbar edge="start" variant="dense">
           
          
       
            <IconButton
              sx={{ color: theme.palette.primary.contrastText }}
              component={Link}
              to="/home"
            >
              <Avatar src= {"/Images/EthioB2blogo.png"} mr={6} />
              <span
                style={{
                  padding: "0",
                  marginLeft: 6,
                  fontSize: 12,
                  fontWeight: "bold",
                  color: theme.palette.primary.contrastText,
                }}
              >
                { "Admin Ethio B2B"}
                <br></br>

                <span style={{ fontWeight: "normal" }}>
                  {" "}
                  {pageHeader?.length > 0 ? pageHeader : ""}
                </span>
              </span>
            </IconButton>
            <Typography
              variant="body1"
              component="div"
              sx={{ flexGrow: 1 }}
            ></Typography>

            <Stack
              direction="row"
              spacing={2}
              sx={{ display: { xs: "none", md: "block" } }}
            >
              <Button component={Link} to={"/News"} color="inherit">
                {t("news")}
              </Button>
              |
              <Button component={Link} to={"/AboutUs"} color="inherit">
                {t("about us")}
              </Button>
              |
                 {!(globalUser === null) ? (
                    <>
                  
                     
                          <Button
                            id="demo-customized-button"
                            aria-controls={
                              AdminOpen  ? "demo-customized-menu" : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={AdminOpen  ? "true" : undefined}
                            variant="contained"
                            disableElevation
                               onClick={(e)=>handleAdminClick(e)}
                            endIcon={<KeyboardArrowDownIcon />}
                          >
                            {t("admins")}
                          </Button>
                          <StyledMenu
                            backgroundColor={theme.palette.primary.dark}
                            id="demo-customized-menu"
                            MenuListProps={{
                              "aria-labelledby": "demo-customized-button",
                            }}
                            anchorEl={anchorAdminEl}
                            open={AdminOpen }
                            onClose={handleAdminClose}
                          >
                           
                              <MenuItem
                                component={Link}
                                to={"/Users"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <PeopleOutline />
                                {t("Users")}
                              </MenuItem>
                         
                              <MenuItem
                                component={Link}
                                to={"/Customers"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <PeopleAlt />
                                {t("Customers")}
                              </MenuItem>
                        
                              <MenuItem
                                component={Link}
                                to={"/CustomersForApproval"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <EvStationSharp />
                                {t("Prospects")}
                              </MenuItem>
                          
                            <Divider sx={{ my: 0.5 }} />
                         
                              <MenuItem
                                component={Link}
                                to={"/Items"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <CategoryRounded />
                                Items
                              </MenuItem>
                      
                          
                              <MenuItem
                                component={Link}
                                to={"/ItemCategories"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <CategoryOutlined />
                                Item Categories
                              </MenuItem>
                          
                          
                            <Divider sx={{ my: 0.5 }} />
                            <MenuItem
                              component={Link}
                              to={"/Reports"}
                              color="inherit"
                              disableRipple
                              onClick={handleAdminClose}
                            >
                              <AssessmentOutlined />
                              {t("Reports")}
                            </MenuItem>
                          
                             
                          <MenuItem
                            component={Link}
                            to={"/Users"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <PeopleOutline />
                            {t("Users")}
                          </MenuItem>
                      
                            <MenuItem
                              component={Link}
                              to={"/Security"}
                              color="inherit"
                              disableRipple
                              onClick={handleAdminClose}
                            >
                              <VpnLockOutlined />
                              {t("Security")}
                            </MenuItem>
                          </StyledMenu>
                       
                      {/*   {globalUser && (globalUser!==null) &&
                <IconButton variant="standard">
              
              <Badge badgeContent={selectedItems.length} color="secondary">
              <NewOrder data={null} Type="Purchase" icon={<AddShoppingCartIcon />} Title="title" />
              </Badge>{" "}
            </IconButton>
} */}
                    </>
                  ) : (
                    ""
                  )}
             
              {globalUser === null ? (
                <Button
                  endIcon={<Login />}
                  component={Link}
                  to={"/LogIn"}
                  color="inherit"
                >
                  <span>{t("log in")}</span>
                </Button>
              ) : (
                <>
                  <Button
                    id="demo-customized-button"
                    aria-controls={
                      UserPOpen ? "demo-customized-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={UserPOpen ? "true" : undefined}
                    variant="contained"
                    disableElevation
                    onClick={(e)=>{handleUserPClick(e)}}
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    <span style={{ padding: 0, margin: 0, fontSize: 10 }}>
                      {t("log out")}
                      <br></br>
                      <span style={{ fontSize: 8 }}>
                        {globalUser.Name.substring(0, 10)}
                      </span>
                    </span>
                    <Avatar sx={{ marginLeft: 1 }} src={globalUser.Logo} />
                  </Button>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      "aria-labelledby": "demo-customized-button",
                    }}
                    anchorEl={anchorUserPEl}
                    open={UserPOpen}
                    onClose={handleUserPClose}
                  >
                    <MenuItem
                      component={Link}
                      to={"/LogIn"}
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      onClick={() => {
                        setGlobalUser(null);
                        setSelectedItems([]);
                        setPageHeader("");
                        handleUserPClose();
                        
                      }}
                    >
                      <LogoutOutlined />
                      {t("log out")}
                    </MenuItem>
                    <MenuItem
                      disableRipple
                      sx={{ color: "black", borderRadius: 3 }}
                      //onClick={handleUserPClose}
                    >
                      <MessageOutlined />

                      <MessagesModel
                        Title={t("messages")}
                        data={globalUser}
                        icon={<div> {t("messages")}</div>}
                      />
                    </MenuItem>
                    <MenuItem
                      disableRipple
                      sx={{ color: "black", borderRadius: 3 }}
                    >
                      <EvStationSharp />

                      <UserRegisterComp
                        Title="User Profile"
                        data={globalUser}
                        icon={<div>{t("user profile")}</div>}
                      />
                    </MenuItem>
                   
                    <MenuItem
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <Language />
                      <TextField
                        id="Languagesfull"
                        select
                        size="small"
                        variant="standard"
                        defaultValue={selectedLanguage}
                        color="primary"
                        onChange={(e) => {
                          setSelectedLanguage(e.target.value);
                          i18n.changeLanguage(e.target.value);
                        }}
                        InputProps={{
                          style: { width: "90%" },
                        }}
                        sx={{ alignItems: "center", color: "black" }}
                        FormHelperTextProps={{ sx: { color: "black" } }}
                        helperText={t("select language")}
                      >
                        {Languegs.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </MenuItem>
                  </StyledMenu>
                </>
              )}
              {/*    <TextField
              id="Languagesfull"
              select
              size="small"
              variant="standard"
              defaultValue="en"
              color="primary"
              onChange={(e) => {
                i18n.changeLanguage(e.target.value);
              
              }}
              InputProps={{
                style: { color: "white", width: "90%" },
              }}
              sx={{ alignItems: "center" }}
              helperText="Select Language"
            >
              {Languegs.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField> */}
            </Stack>

            <Stack sx={{ display: { xs: "block", md: "none" } }}>
              {globalUser === null ? (
                <Button
                  endIcon={<Login />}
                  component={Link}
                  to={"/LogIn"}
                  color="inherit"
                >
                  <span>{t("log in")}</span>
                </Button>
              ) : (
                <>
                  <Button
                    id="demo-customized-button"
                    aria-controls={
                      UserPOpen ? "demo-customized-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={UserPOpen ? "true" : undefined}
                    variant="contained"
                    disableElevation
                      onClick={(e)=>{handleUserPClick(e)}}
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    <span style={{ padding: 0, margin: 0, fontSize: 10 }}>
                      {t("log out")}
                      <br></br>
                      <span style={{ fontSize: 8 }}>
                        {globalUser.Name.substring(0, 10)}
                      </span>
                    </span>
                    <Avatar sx={{ marginLeft: 1 }} src={globalUser.Logo} />
                  </Button>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      "aria-labelledby": "demo-customized-button",
                    }}
                    anchorEl={anchorUserPEl}
                    open={UserPOpen}
                    onClose={handleUserPClose}
                  >
                    <MenuItem
                      component={Link}
                      to={"/LogIn"}
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      onClick={() => {
                        setGlobalUser(null);
                        setSelectedItems([]);
                        setPageHeader("");
                        handleUserPClose();
                      }}
                    >
                      <LogoutOutlined />
                      {t("log out")}
                    </MenuItem>
                    <MenuItem
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <MessageOutlined />
                      <MessagesModel
                        Title={t("messages")}
                        data={globalUser}
                        icon={<div> {t("messages")}</div>}
                      />
                    </MenuItem>
                    <MenuItem
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <ManageAccountsOutlined />

                      <UserRegisterComp
                        Title="User Profile"
                        data={globalUser}
                        icon={<div>{t("user profile")}</div>}
                      />
                    </MenuItem>
                  
                    <MenuItem
                      color="inherit"
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <Language />
                      <TextField
                        id="Languagesfull"
                        select
                        size="small"
                        variant="standard"
                        sx={{ color: "black" }}
                        defaultValue={selectedLanguage}
                        color="primary"
                        onChange={(e) => {
                          setSelectedLanguage(e.target.value);
                          i18n.changeLanguage(e.target.value);
                        }}
                        InputProps={{
                          style: { width: "90%", color: "black" },
                        }}
                        FormHelperTextProps={{ sx: { color: "black" } }}
                        helperText={t("select language")}
                      >
                        {Languegs.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </MenuItem>
                  </StyledMenu>
                </>
              )}

              <IconButton
                onClick={() => {
                  setOpenDrawer(true);
                }}
              >
                <MenuIcon />
              </IconButton>

              
<Drawer
        variant="permanent"
        open={openDrawer}
        sx={{
           marginTop: "64px", // <-- Drawer starts below AppBar
            height: "calc(100% - 64px)", // Adjust height
          width: openDrawer ? drawerWidth : globalUser && globalUser!==null ? 40:0,
          flexShrink: 0,
          whiteSpace: "nowrap",
          transition: "width 0.3s",
          "& .MuiDrawer-paper": {
            width: openDrawer ? drawerWidth : globalUser && globalUser!==null ? 40:0,
            boxSizing: "border-box",
            transition: "width 0.3s",
         direction: 'column',
         flex: 1,
       
          },
        }}
      >
         {/* <Toolbar edge="start" variant="dense" sx={{justifyContent: open ? 'flex-end' : 'center', px: [1]}}> */}
         <Button variant="contained" sx={{height:55,paddingLeft:0}} onClick={()=>{toggleDrawer();setOpenOnSideBar('')}} >
            {openDrawer ? <ChevronLeft /> : <MenuIcon /> }
             {openDrawer && <Typography variant="h6" noWrap component="div">
            Menu
          </Typography> }  
          </Button>
         
       {/* </Toolbar> */}

         
     {/* Settings Parent Menu */}
           
                  
                     <Tooltip title="Admins">
          <ListItem button onClick={()=>{
            setOpen(true);
            openOnSideBar==='Admins'?
            setOpenOnSideBar(''):setOpenOnSideBar('Admins');
            }}>
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            {openDrawer && <ListItemText primary= {t("admins")} />}
            {openDrawer && (openOnSideBar==='Admins'  ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>
          </Tooltip>

          {/* Child Admins (Collapsible) */}
          <Collapse in={openOnSideBar==='Admins'?true:false} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{marginLeft:5}}>
             
               
                      
                          <MenuItem
                            component={Link}
                            to={"/Customers"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <PeopleAlt />
                            {t("Customers")}
                          </MenuItem>
                       
                          <MenuItem
                            component={Link}
                            to={"/CustomersForApproval"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <EvStationSharp />
                            {t("Prospects")}
                          </MenuItem>
                      
                        <Divider sx={{ my: 0.5 }} />
                                               <MenuItem
                            component={Link}
                            to={"/Items"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <CategoryRounded />
                            Items
                          </MenuItem>
               
                      
                          <MenuItem
                            component={Link}
                            to={"/ItemCategories"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <CategoryOutlined />
                            Item Categories
                          </MenuItem>
                      
                       
                       
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                          component={Link}
                          to={"/Reports"}
                          color="inherit"
                          disableRipple
                          onClick={handleAdminClose}
                        >
                          <AssessmentOutlined />
                          {t("Reports")}
                        </MenuItem>
                     
                          <MenuItem
                            component={Link}
                            to={"/Users"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <PeopleOutline />
                            {t("Users")}
                          </MenuItem>
                    
                          <MenuItem
                            component={Link}
                            to={"/Security"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <VpnLockOutlined />
                            {t("Security")}
                          </MenuItem>
                     
            </List>
          </Collapse>
        <Divider />
       

          {/* Profile */}
          <Tooltip title="News">
          <ListItem component={Link} to={"/News"}>
            <ListItemIcon>
              <ArticleOutlined />
            </ListItemIcon>
            {t("news")}
            </ListItem>
            </Tooltip>
            <Divider />
             <Tooltip title="About Us">
             <ListItem component={Link} to={"/AboutUs"}>
             <ListItemIcon>
              <AccountCircle />
            </ListItemIcon>
            {t("about us")} 
            </ListItem>
              </Tooltip>
           
             
              {globalUser === null ? (
                <Button
                  endIcon={<Login />}
                  component={Link}
                  to={"/LogIn"}
                  color="inherit"
                >
                  <span>{t("log in")}</span>
                </Button>
              ) : (
                <>
                  <Button
                    id="demo-customized-button"
                    aria-controls={
                      UserPOpen ? "demo-customized-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={UserPOpen ? "true" : undefined}
                    variant="contained"
                    disableElevation
                       onClick={(e)=>{handleUserPClick(e)}}
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    <span style={{ padding: 0, margin: 0, fontSize: 10 }}>
                      {t("log out")}
                      <br></br>
                      <span style={{ fontSize: 8 }}>
                        {globalUser.Name.substring(0, 10)}
                      </span>
                    </span>
                    <Avatar sx={{ marginLeft: 1 }} src={globalUser.Logo} />
                  </Button>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      "aria-labelledby": "demo-customized-button",
                    }}
                    anchorEl={anchorUserPEl}
                    openDrawer={UserPOpen}
                    onClose={handleUserPClose}
                  >
                    <MenuItem
                      component={Link}
                      to={"/LogIn"}
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      onClick={() => {
                        setGlobalUser(null);
                        setSelectedItems([]);
                        setPageHeader("");
                        handleUserPClose();
                      }}
                    >
                      <LogoutOutlined />
                      {t("log out")}
                    </MenuItem>
                    <MenuItem
                      disableRipple
                      sx={{ color: "black", borderRadius: 3 }}
                      //onClick={handleUserPClose}
                    >
                      <MessageOutlined />

                      <MessagesModel
                        Title={t("messages")}
                        data={globalUser}
                        icon={<div> {t("messages")}</div>}
                      />
                    </MenuItem>
                    <MenuItem
                      disableRipple
                      sx={{ color: "black", borderRadius: 3 }}
                    >
                      <EvStationSharp />

                      <UserRegisterComp
                        Title="User Profile"
                        data={globalUser}
                        icon={<div>{t("user profile")}</div>}
                      />
                    </MenuItem>
                   
                    <MenuItem
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <Language />
                      <TextField
                        id="Languagesfull"
                        select
                        size="small"
                        variant="standard"
                        defaultValue={selectedLanguage}
                        color="primary"
                        onChange={(e) => {
                          setSelectedLanguage(e.target.value);
                          i18n.changeLanguage(e.target.value);
                        }}
                        InputProps={{
                          style: { width: "90%" },
                        }}
                        sx={{ alignItems: "center", color: "black" }}
                        FormHelperTextProps={{ sx: { color: "black" } }}
                        helperText={t("select language")}
                      >
                        {Languegs.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </MenuItem>
                  </StyledMenu>
                </>
              )}
              {/*    <TextField
              id="Languagesfull"
              select
              size="small"
              variant="standard"
              defaultValue="en"
              color="primary"
              onChange={(e) => {
                i18n.changeLanguage(e.target.value);
              
              }}
              InputProps={{
                style: { color: "white", width: "90%" },
              }}
              sx={{ alignItems: "center" }}
              helperText="Select Language"
            >
              {Languegs.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField> */}
            

            <Stack sx={{ display: { xs: "block", md: "none" } }}>
              {globalUser === null ? (
                <Button
                  endIcon={<Login />}
                  component={Link}
                  to={"/LogIn"}
                  color="inherit"
                >
                  <span>{t("log in")}</span>
                </Button>
              ) : (
                <>
                  <Button
                    id="demo-customized-button"
                    aria-controls={
                      UserPOpen ? "demo-customized-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={UserPOpen ? "true" : undefined}
                    variant="contained"
                    disableElevation
                      onClick={(e)=>{handleUserPClick(e)}}
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    <span style={{ padding: 0, margin: 0, fontSize: 10 }}>
                      {t("log out")}
                      <br></br>
                      <span style={{ fontSize: 8 }}>
                        {globalUser.Name.substring(0, 10)}
                      </span>
                    </span>
                    <Avatar sx={{ marginLeft: 1 }} src={globalUser.Logo} />
                  </Button>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      "aria-labelledby": "demo-customized-button",
                    }}
                    anchorEl={anchorUserPEl}
                    openDrawer={UserPOpen}
                    onClose={handleUserPClose}
                  >
                    <MenuItem
                      component={Link}
                      to={"/LogIn"}
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      onClick={() => {
                        setGlobalUser(null);
                        setSelectedItems([]);
                        setPageHeader("");
                        handleUserPClose();
                      }}
                    >
                      <LogoutOutlined />
                      {t("log out")}
                    </MenuItem>
                    <MenuItem
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <MessageOutlined />
                      <MessagesModel
                        Title={t("messages")}
                        data={globalUser}
                        icon={<div> {t("messages")}</div>}
                      />
                    </MenuItem>
                    <MenuItem
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <ManageAccountsOutlined />

                      <UserRegisterComp
                        Title="User Profile"
                        data={globalUser}
                        icon={<div>{t("user profile")}</div>}
                      />
                    </MenuItem>
                   
                    <MenuItem
                      color="inherit"
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <Language />
                      <TextField
                        id="Languagesfull"
                        select
                        size="small"
                        variant="standard"
                        sx={{ color: "black" }}
                        defaultValue={selectedLanguage}
                        color="primary"
                        onChange={(e) => {
                          setSelectedLanguage(e.target.value);
                          i18n.changeLanguage(e.target.value);
                        }}
                        InputProps={{
                          style: { width: "90%", color: "black" },
                        }}
                        FormHelperTextProps={{ sx: { color: "black" } }}
                        helperText={t("select language")}
                      >
                        {Languegs.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </MenuItem>
                  </StyledMenu>
                </>
              )}

              <IconButton
                onClick={() => {
                  setOpenDrawer(true);
                }}
              >
                <MenuIcon />
              </IconButton>
              <SwipeableDrawer
                anchor="right"
                variant="standard"
                openDrawer={openDrawer}
                onClose={() => setOpenDrawer(false)}
                onOpen={() => setOpenDrawer(true)}
                PaperProps={{
                  sx: {
                    backgroundColor: theme.palette.primary.main,
                  },
                }}
              >
                <Stack spacing={2}>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setOpenDrawer(false);
                    }}
                    endIcon={<KeyboardReturnOutlined />}
                  ></Button>
                  <Button
                    component={Link}
                    to={"/News"}
                    variant="contained"
                    onClick={() => setOpenDrawer(false)}
                  >
                    {t("news")}
                  </Button>
                  <Button
                    component={Link}
                    to={"/AboutUs"}
                    variant="contained"
                    onClick={() => setOpenDrawer(false)}
                  >
                    {t("about us")}
                  </Button>

                  {!(globalUser === null) ? (
                    <>
                  
                          <Button
                            id="demo-customized-button"
                            aria-controls={
                              AdminOpen  ? "demo-customized-menu" : undefined
                            }
                            aria-haspopup="true"
                            aria-expanded={AdminOpen  ? "true" : undefined}
                            variant="contained"
                            disableElevation
                               onClick={(e)=>handleAdminClick(e)}
                            endIcon={<KeyboardArrowDownIcon />}
                          >
                            {t("admins")}
                          </Button>
                          <StyledMenu
                            backgroundColor={theme.palette.primary.dark}
                            id="demo-customized-menu"
                            MenuListProps={{
                              "aria-labelledby": "demo-customized-button",
                            }}
                            anchorEl={anchorAdminEl}
                            open={AdminOpen }
                            onClose={handleAdminClose}
                          >
                          
                              <MenuItem
                                component={Link}
                                to={"/Users"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <PeopleOutline />
                                {t("Users")}
                              </MenuItem>
                         
                              <MenuItem
                                component={Link}
                                to={"/Customers"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <PeopleAlt />
                                {t("Customers")}
                              </MenuItem>
                         
                              <MenuItem
                                component={Link}
                                to={"/CustomersForApproval"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <EvStationSharp />
                                {t("Prospects")}
                              </MenuItem>
                          
                            <Divider sx={{ my: 0.5 }} />
                          
                              <MenuItem
                                component={Link}
                                to={"/Items"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <CategoryRounded />
                                Items
                              </MenuItem>
                        
                              <MenuItem
                                component={Link}
                                to={"/ItemCategories"}
                                color="inherit"
                                disableRipple
                                onClick={handleAdminClose}
                              >
                                <CategoryOutlined />
                                Item Categories
                              </MenuItem>
                        
                      
                            <Divider sx={{ my: 0.5 }} />
                            <MenuItem
                              component={Link}
                              to={"/Reports"}
                              color="inherit"
                              disableRipple
                              onClick={handleAdminClose}
                            >
                              <AssessmentOutlined />
                              {t("Reports")}
                            </MenuItem>
                         
                             
                          <MenuItem
                            component={Link}
                            to={"/Users"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <PeopleOutline />
                            {t("Users")}
                          </MenuItem>
                      
                            <MenuItem
                              component={Link}
                              to={"/Security"}
                              color="inherit"
                              disableRipple
                              onClick={handleAdminClose}
                            >
                              <VpnLockOutlined />
                              {t("Security")}
                            </MenuItem>
                          </StyledMenu>
                        </>
        
                  ) : (
                    ""
                  )}
                  {globalUser === null ? (
                    <Button
                      endIcon={<Login />}
                      component={Link}
                      to={"/LogIn"}
                      color="inherit"
                    >
                      <span>{t("log in")}</span>
                    </Button>
                  ) : (
                    <>
                      <Button
                        id="demo-customized-button"
                        aria-controls={
                          UserPOpen ? "demo-customized-menu" : undefined
                        }
                        aria-haspopup="true"
                        aria-expanded={UserPOpen ? "true" : undefined}
                        variant="contained"
                        disableElevation
                          onClick={(e)=>{handleUserPClick(e)}}
                        endIcon={<KeyboardArrowDownIcon />}
                      >
                        <span style={{ padding: 0, margin: 0, fontSize: 10 }}>
                          {t("log out")}
                          <br></br>
                          <span style={{ fontSize: 8 }}>
                            {globalUser.Name.substring(0, 10)}
                          </span>
                        </span>
                        <Avatar sx={{ marginLeft: 1 }} src={globalUser.Logo} />
                      </Button>
                      <StyledMenu
                        id="demo-customized-menu"
                        MenuListProps={{
                          "aria-labelledby": "demo-customized-button",
                        }}
                        anchorEl={anchorUserPEl}
                        open={UserPOpen}
                        onClose={handleUserPClose}
                      >
                        <MenuItem
                          component={Link}
                          to={"/LogIn"}
                          sx={{ color: "black", borderRadius: 3 }}
                          disableRipple
                          onClick={() => {
                            setGlobalUser(null);
                            setSelectedItems([]);
                            setPageHeader("");
                            handleUserPClose();
                          }}
                        >
                          <LogoutOutlined />
                          {t("log out")}
                        </MenuItem>
                        <MenuItem
                          sx={{ color: "black", borderRadius: 3 }}
                          disableRipple
                          //onClick={handleUserPClose}
                        >
                          <MessageOutlined />
                          <MessagesModel
                            Title={t("messages")}
                            data={globalUser}
                            icon={<div> {t("messages")}</div>}
                          />
                        </MenuItem>
                        <MenuItem
                          sx={{ color: "black", borderRadius: 3 }}
                          disableRipple
                          //onClick={handleUserPClose}
                        >
                          <ManageAccountsOutlined />

                          <UserRegisterComp
                            Title="User Profile"
                            data={globalUser}
                            icon={<div>{t("user profile")}</div>}
                          />
                        </MenuItem>
                      
                        <MenuItem
                          sx={{ color: "black", borderRadius: 3 }}
                          disableRipple
                          //onClick={handleUserPClose}
                        >
                          <Language />
                          <TextField
                            id="Languagesfull"
                            select
                            size="small"
                            variant="standard"
                            defaultValue={selectedLanguage}
                            color="primary"
                            onChange={(e) => {
                              setSelectedLanguage(e.target.value);
                              i18n.changeLanguage(e.target.value);
                            }}
                            InputProps={{
                              style: { width: "90%" },
                            }}
                            sx={{ alignItems: "center", color: "black" }}
                            FormHelperTextProps={{ sx: { color: "black" } }}
                            helperText={t("select language")}
                          >
                            {Languegs.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                            ))}
                          </TextField>
                        </MenuItem>
                      </StyledMenu>
                    </>
                  )}
                </Stack>
              </SwipeableDrawer>
            </Stack>
          
      </Drawer>



            </Stack>
          </Toolbar>
        </AppBar>

        <div className="App"  style={{
          flexGrow: 1,
          padding: "10px 6px 6px",
          transition: "margin 0.3s",
          marginLeft: open ? drawerWidth : globalUser && globalUser!==null ? 40:0,
        }}>
          <Routes>
            <Route path="/" element={<LogInModel />} />
            <Route path="/Home" element={<HomeComp />} />
            <Route path="/Customers" element={<ComstomersComp />} />
            <Route
              path="/CustomersForApproval"
              element={<CustomersCompForApproval />}
            />
                <Route path="/Items" element={<ItemsComp />} />
            <Route path="/ItemCategories" element={<ItemCategoriesComp />} />
            <Route path="/Users" element={<UsersComp />} />
            <Route path="/News" element={<NewsComp />} />
            <Route path="/SingleStory" element={<SingleStory />} />
            <Route path="/EditStory" element={<EditStory />} />
            <Route path="/Security" element={<SecurityComp />} />

            <Route path="/AboutUs" element={<AboutusComp />} />

            <Route path="*" element={<LogInModel />} />
          </Routes>
        </div>
        {/* Sidebar Drawer */}
        {globalUser && globalUser !== null && (
      <Drawer
        variant="permanent"
        open={open}
        sx={{
           marginTop: "64px", // <-- Drawer starts below AppBar
            height: "calc(100% - 64px)", // Adjust height
          width: open ? drawerWidth : globalUser && globalUser!==null ? 40:0,
          flexShrink: 0,
          whiteSpace: "nowrap",
          transition: "width 0.3s",
          "& .MuiDrawer-paper": {
            width: open ? drawerWidth : globalUser && globalUser!==null ? 40:0,
            boxSizing: "border-box",
            transition: "width 0.3s",
         direction: 'column',
         flex: 1,
       
          },
        }}
      >
         {/* <Toolbar edge="start" variant="dense" sx={{justifyContent: open ? 'flex-end' : 'center', px: [1]}}> */}
         <Button variant="contained" sx={{height:55,paddingLeft:0}} onClick={()=>{toggleDrawer();setOpenOnSideBar('')}} >
            {open ? <ChevronLeft /> : <MenuIcon /> }
             {open && <Typography variant="h6" noWrap component="div">
            Menu
          </Typography> }  
          </Button>
         


         
            
     {/* Settings Parent Menu */}
       
                     <Tooltip title="Admins">
          <ListItem button onClick={()=>{
            setOpen(true);
            openOnSideBar==='Admins'?
            setOpenOnSideBar(''):setOpenOnSideBar('Admins');
            }}>
            <ListItemIcon>
              <Settings />
            </ListItemIcon>
            {open && <ListItemText primary= {t("admins")} />}
            {open && (openOnSideBar==='Admins'  ? <ExpandLess /> : <ExpandMore />)}
          </ListItem>
          </Tooltip>

          {/* Child Admins (Collapsible) */}
          <Collapse in={openOnSideBar==='Admins'?true:false} timeout="auto" unmountOnExit>
            <List component="div" disablePadding sx={{marginLeft:5}}>
             
                   
                     
                          <MenuItem
                            component={Link}
                            to={"/Customers"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <PeopleAlt />
                            {t("Customers")}
                          </MenuItem>
                     
                          <MenuItem
                            component={Link}
                            to={"/CustomersForApproval"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <EvStationSharp />
                            {t("Prospects")}
                          </MenuItem>
                      
                        <Divider sx={{ my: 0.5 }} />
                       
                          <MenuItem
                            component={Link}
                            to={"/Items"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <CategoryRounded />
                            Items
                          </MenuItem>
                    
                                              <MenuItem
                            component={Link}
                            to={"/ItemCategories"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <CategoryOutlined />
                            Item Categories
                          </MenuItem>
                  
                      
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                          component={Link}
                          to={"/Reports"}
                          color="inherit"
                          disableRipple
                          onClick={handleAdminClose}
                        >
                          <AssessmentOutlined />
                          {t("Reports")}
                        </MenuItem>
                  
                          <MenuItem
                            component={Link}
                            to={"/Setting"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <SettingsOutlined />
                            {t("Setting")}
                          </MenuItem>
                     
                          <MenuItem
                            component={Link}
                            to={"/Users"}
                            color="inherit"
                            disableRipple
                            onClick={()=>{handleAdminClose();}}
                          >
                            <PeopleOutline />
                            {t("Users")}
                          </MenuItem>
                    
                          <MenuItem
                            component={Link}
                            to={"/Security"}
                            color="inherit"
                            disableRipple
                            onClick={handleAdminClose}
                          >
                            <VpnLockOutlined />
                            {t("Security")}
                          </MenuItem>
                       
            </List>
          </Collapse>
        <Divider />
       

          {/* Profile */}
          <Tooltip title="News">
          <ListItem component={Link} to={"/News"}>
            <ListItemIcon>
              <ArticleOutlined />
            </ListItemIcon>
            {t("news")}
            </ListItem>
            </Tooltip>
            <Divider />
             <Tooltip title="About Us">
             <ListItem component={Link} to={"/AboutUs"}>
             <ListItemIcon>
              <AccountCircle />
            </ListItemIcon>
            {t("about us")} 
            </ListItem>
              </Tooltip>
           
             
              {globalUser === null ? (
                <Button
                  endIcon={<Login />}
                  component={Link}
                  to={"/LogIn"}
                  color="inherit"
                >
                  <span>{t("log in")}</span>
                </Button>
              ) : (
                <>
                  <Button
                    id="demo-customized-button"
                    aria-controls={
                      UserPOpen ? "demo-customized-menu" : undefined
                    }
                    aria-haspopup="true"
                    aria-expanded={UserPOpen ? "true" : undefined}
                    variant="contained"
                    disableElevation
                       onClick={(e)=>{handleUserPClick(e)}}
                    endIcon={<KeyboardArrowDownIcon />}
                  >
                    <span style={{ padding: 0, margin: 0, fontSize: 10 }}>
                      {t("log out")}
                      <br></br>
                      <span style={{ fontSize: 8 }}>
                        {globalUser.Name.substring(0, 10)}
                      </span>
                    </span>
                    <Avatar sx={{ marginLeft: 1 }} src={globalUser.Logo} />
                  </Button>
                  <StyledMenu
                    id="demo-customized-menu"
                    MenuListProps={{
                      "aria-labelledby": "demo-customized-button",
                    }}
                    anchorEl={anchorUserPEl}
                    open={UserPOpen}
                    onClose={handleUserPClose}
                  >
                    <MenuItem
                      component={Link}
                      to={"/LogIn"}
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      onClick={() => {
                        setGlobalUser(null);
                        setSelectedItems([]);
                        setPageHeader("");
                        handleUserPClose();
                      }}
                    >
                      <LogoutOutlined />
                      {t("log out")}
                    </MenuItem>
                    <MenuItem
                      disableRipple
                      sx={{ color: "black", borderRadius: 3 }}
                      //onClick={handleUserPClose}
                    >
                      <MessageOutlined />

                      <MessagesModel
                        Title={t("messages")}
                        data={globalUser}
                        icon={<div> {t("messages")}</div>}
                      />
                    </MenuItem>
                    <MenuItem
                      disableRipple
                      sx={{ color: "black", borderRadius: 3 }}
                    >
                      <EvStationSharp />

                      <UserRegisterComp
                        Title="User Profile"
                        data={globalUser}
                        icon={<div>{t("user profile")}</div>}
                      />
                    </MenuItem>
                  
                    <MenuItem
                      sx={{ color: "black", borderRadius: 3 }}
                      disableRipple
                      //onClick={handleUserPClose}
                    >
                      <Language />
                      <TextField
                        id="Languagesfull"
                        select
                        size="small"
                        variant="standard"
                        defaultValue={selectedLanguage}
                        color="primary"
                        onChange={(e) => {
                          setSelectedLanguage(e.target.value);
                          i18n.changeLanguage(e.target.value);
                        }}
                        InputProps={{
                          style: { width: "90%" },
                        }}
                        sx={{ alignItems: "center", color: "black" }}
                        FormHelperTextProps={{ sx: { color: "black" } }}
                        helperText={t("select language")}
                      >
                        {Languegs.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </MenuItem>
                  </StyledMenu>
                </>
              )}
             
          
      </Drawer>
        )}
      </BrowserRouter>

  );
}

export default App;
